// components/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  const isAdmin = localStorage.getItem('isAdmin');

  // Check both token and admin status
  if (!token || isAdmin !== 'true') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
